module.exports = __webpack_public_path__ + "static/media/recurring-contact.7af89e5d.svg";